import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type MeterDimension = { name: string, apiKey: string }

// MeterDefinition primitive (FNP-214). The legacy MeterType enum conflated what
// is measured with how it is aggregated; it is replaced by MeterAggregation +
// MeterGrain per the FNP-212 design (Confluence 1451196417 §3).
export enum MeterAggregation {
    COUNT = 'COUNT',
    SUM = 'SUM',
    MAX = 'MAX',
    DURATION = 'DURATION',
    LAST_VALUE = 'LAST_VALUE',
    ACTIVE_COUNT = 'ACTIVE_COUNT',
}

export enum MeterGrain {
    HOUR = 'HOUR',
    DAY = 'DAY',
    MONTH = 'MONTH',
}

export enum MeterResetPolicy {
    NEVER = 'NEVER',
    PERIOD_START = 'PERIOD_START',
}

export enum MeterPurpose {
    BILLABLE = 'BILLABLE',
    AUDIT_ONLY = 'AUDIT_ONLY',
    BOTH = 'BOTH',
}

export enum MeterStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    DEPRECATED = 'DEPRECATED',
    RETIRED = 'RETIRED',
}

export type Meter = {
    id: string,
    name: string,
    meterCode: string,
    aggregation: MeterAggregation,
    grain: MeterGrain,
    unit?: string,
    resetPolicy: MeterResetPolicy,
    purpose: MeterPurpose,
    latenessWindowMinutes: number,
    watermarkDelayMinutes: number,
    status: MeterStatus,
    dimensions: MeterDimension[],
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    // FNP-748: who last activated/retired the meter (billing-api Meter.updatedByUsername).
    updatedByUsername?: string,
    created?: string,
    updated?: string,
}


export interface IMeterTableColumn extends ITableColumn {
    render?: (item: Meter) => ReactNode;
}
